import React from "react";
import { useHistory } from "react-router";
import { useMutation, useQueryClient } from "react-query";

// components
import { OrderCsvUpload } from "@secondcloset/web-components";

import { createOrder } from "../../../api/fulfillment/order";
import { fetchAndDownloadCsvTemplate } from "../../../api/fulfillment/downloadCSV";
import { fetchProductsIndex } from "../../../api/fulfillment/product";

export interface OrderCsvUploadV1Prop {
  pageRef: React.RefObject<HTMLDivElement>;
  organizationId: string;
}

export const OrderCsvUploadV1: React.FC<OrderCsvUploadV1Prop> = ({ pageRef, organizationId }) => {
  const history = useHistory();
  const queryClient = useQueryClient();
  const { mutateAsync: doCreateOrder } = useMutation(createOrder);
  const { mutate: fetchCSVTemplate } = useMutation(fetchAndDownloadCsvTemplate);

  const getProductBySku = async (sku: string) => {
    const products = await queryClient.fetchQuery(["fetchProductsIndex", sku], () =>
      fetchProductsIndex({ sku, active: true })
    );
    return products.data.find((product) => product.sku === sku) || null;
  };

  return (
    <OrderCsvUpload
      onOrderCreate={({ orders }) => doCreateOrder({ orders: { ...orders, organization_id: organizationId } })}
      getProductBySku={getProductBySku}
      onOrdersCreateSuccess={() => history.push(`/organizations/${organizationId}/orders`)}
      onDownloadTemplate={() => {
        pageRef.current && fetchCSVTemplate({ key: "fulfillment_create_order", node: pageRef.current });
      }}
    />
  );
};
